import type { ReportFreshness, SeriesPeriod } from "@nexus/widget-kit";

export const CDNSA_DAILY_TREND_CONTRACT = { name: "cdnsa-daily-trend", version: 1 } as const;

export interface CdnsaDailyTrendData {
  points: {
    day: string;
    theft_for_restreaming: number;
    cdn_leeching: number;
    new_accounts?: number | null;
  }[];
  freshness: ReportFreshness | null;
  period?: SeriesPeriod | null;
}
